module.exports = __webpack_public_path__ + "static/media/best-currency-converter.0cfe3164.png";